import {MapBounds} from '../../../entities/boost/model/types';

export function getMapBoundsQueryKey(bounds?: MapBounds) {
  if (!bounds) {
    return ['mapBounds'];
  }

  const {nw, se} = bounds;
  return ['mapBounds', nw.lat, nw.lng, se.lat, se.lng];
}
